
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ChatIcon from "@/components/icons/ChatIcon.vue";

  import RouteNames from "@/entities/RouteNames";
  import RouteParams from "@/entities/RouteParams";

  @Component({
    components: {
      ChatIcon,
    },
  })
  export default class GoToInbox extends Vue {
    @Prop({ type: String, required: true }) readonly recipientUserId!: string;


     onLinkClick  (event: MouseEvent, navigate: (event: MouseEvent) => void) {

       this.$emit('link-click', event, this.recipientUserId);
      navigate(event);
    };
    get inboxPage(): RouteParams<{ recipientUserId: string }> {
      return {
        name: RouteNames.INBOX,
        query: { recipientUserId: this.recipientUserId },
      };
    }
  }
